import { Component, Input } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

export type CheckboxGroupItem = {
    controlName: string;
    label: string;
};

@Component({
    selector: 'sume-checkbox-group',
    templateUrl: './checkbox-group.component.html',
})
export class CheckboxGroupComponent {
    @Input() formGroup: FormGroup;
    @Input() items: CheckboxGroupItem[] = [];
    @Input() label: string;
    @Input() message = 'Campos obrigatórios';

    get isInvalid(): boolean {
        const controls = this.items
            .map(item => this.formGroup?.get(item.controlName))
            .filter((control): control is AbstractControl => !!control);

        if (controls.length === 0) {
            return false;
        }

        const hasTouched = controls.some(control => control.touched);
        const hasInvalid = controls.some(control => control.invalid);

        return hasTouched && hasInvalid;
    }
}
